import { Component, inject } from '@angular/core';

import { NotificationService } from '@app/core/services/notification';

@Component({
  selector: 'app-notification-container',
  standalone: true,
  imports: [],
  templateUrl: './notification-container.component.html'
})
export class NotificationContainerComponent {
  private notificationService = inject(NotificationService);
  notifications = this.notificationService.notifications$;

  dismiss(id: string): void {
    this.notificationService.dismiss(id);
  }

  executeAction(id: string, callback: () => void): void {
    callback();
    this.dismiss(id);
  }

  getAlertClass(type: string): string {
    switch (type) {
      case 'success': return 'w-full max-w-sm rounded-sm2 border border-ok/40 bg-okpanel p-4 text-ok shadow-ghost';
      case 'error': return 'w-full max-w-sm rounded-sm2 border border-bad/40 bg-badpanel p-4 text-bad shadow-ghost';
      case 'warning': return 'w-full max-w-sm rounded-sm2 border border-warn/40 bg-warnpanel p-4 text-warn shadow-ghost';
      case 'info': return 'w-full max-w-sm rounded-sm2 border border-info/40 bg-infopanel p-4 text-info shadow-ghost';
      default: return 'w-full max-w-sm rounded-sm2 border border-info/40 bg-infopanel p-4 text-info shadow-ghost';
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      case 'info': return 'ℹ';
      default: return 'ℹ';
    }
  }
}
